var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionH2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4844 44H34.7734V41.2852L42.4102 33.5312C43.8294 32.099 45.0208 30.8229 45.9844 29.7031C46.9609 28.5833 47.7031 27.4831 48.2109 26.4023C48.7188 25.3086 48.9727 24.1107 48.9727 22.8086C48.9727 21.194 48.4909 19.9635 47.5273 19.1172C46.5768 18.2578 45.3203 17.8281 43.7578 17.8281C42.3906 17.8281 41.1797 18.0625 40.125 18.5312C39.0703 19 37.9896 19.6641 36.8828 20.5234L35.1445 18.3359C35.8997 17.6979 36.7201 17.1315 37.6055 16.6367C38.5039 16.1419 39.4609 15.7513 40.4766 15.4648C41.5052 15.1784 42.599 15.0352 43.7578 15.0352C45.5156 15.0352 47.0326 15.3411 48.3086 15.9531C49.5846 16.5651 50.5677 17.4375 51.2578 18.5703C51.9609 19.7031 52.3125 21.0508 52.3125 22.6133C52.3125 24.1237 52.013 25.5299 51.4141 26.832C50.8151 28.1211 49.9753 29.4036 48.8945 30.6797C47.8138 31.9427 46.5508 33.2839 45.1055 34.7031L38.8945 40.8945V41.0312H53.4844V44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8555 44H25.5352V30.543H10.5352V44H7.21484V15.4453H10.5352V27.6133H25.5352V15.4453H28.8555V44Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionH2);
export default __webpack_public_path__ + "static/media/section-h2.33c55301e03cdacb8b0f1a479aee1bb3.svg";
export { ForwardRef as ReactComponent };